import { graphql, Environment } from 'react-relay';
import commitMutation from 'relay-commit-mutation-promise';
import getRelayEnvironment from '../../../relayClientEnvironment';

import {
    completeAccountEmailMutation as MutationType,
    completeAccountEmailMutationResponse,
    CompleteAccountEmailInput,
} from './__generated__/completeAccountEmailMutation.graphql';

const mutation = graphql`
    mutation completeAccountEmailMutation($input: CompleteAccountEmailInput!) {
        completeAccountEmail(input: $input) {
            message
        }
    }
`;

export function completeAccountEmailMutation({
    environment = getRelayEnvironment(),
    email,
}: CompleteAccountEmailInput & {
    environment?: Environment;
}): Promise<completeAccountEmailMutationResponse> {
    return commitMutation<MutationType>(environment, {
        mutation,
        variables: {
            input: { email },
        },
    });
}
